<template lang="html">

  <section class="politica-de-privacidad">
    <h1>politica-de-privacidad Component</h1>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'politica-de-privacidad',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
  .politica-de-privacidad {

  }
</style>



// WEBPACK FOOTER //
// src/components/views/politica-de-privacidad.vue